import QueryKeys from '@/utils/QueryKeys';
import { plato_api_image_models_path } from '@/modules/routes';
import { UseQueryOptions } from '@tanstack/react-query';
import { BaseImageModel, ExtraAttributes, ImageModelSchema } from '@/types/api/v2/ImageModelSchema';
import useApi from './useApi';

interface UseImageModelParams<K extends (keyof BaseImageModel)[], E extends (keyof ExtraAttributes)[]> {
  extra_attributes?: E;
  only?: K;
  params?: object;
}

type UseImageModelsOptions<K extends (keyof BaseImageModel)[], E extends (keyof ExtraAttributes)[]> =
  UseImageModelParams<K, E> & Omit<UseQueryOptions<ImageModelSchema<K[number], E[number]>[]>, 'queryFn' | 'queryKey'>;

export default function useImageModels<
  K extends(keyof BaseImageModel)[],
  E extends (keyof ExtraAttributes)[],
>({
  extra_attributes = ([] as any as E),
  only,
  params = {},
  ...queryOptions
}: UseImageModelsOptions<K, E>) {
  return useApi<ImageModelSchema<K[number], E[number]>[], BaseImageModel, K, ExtraAttributes, E>({
    endpoint: plato_api_image_models_path({ extra_attributes, only }),
    extra_attributes,
    only,
    params,
    placeholderData: [],
    queryKey: [QueryKeys.ImageModels, extra_attributes, only],
    ...queryOptions,
  });
}
